
import React, { useEffect, useLayoutEffect } from "react";
import { Col, Modal, Row, Container } from "react-bootstrap";
import IconWithButton from "../IconWithButton/IconWithButton";
import './alertPopup.scss';
import "../modal/QAPDIssuesExistsModal.scss";
import { connect } from "react-redux";
import {
    getCompleteStatusCheckAction,
    resetCompleteStatusCheckStateAction,
    getFeeSchedulesCheckAction,
    resetFeeScheduleCheckStateAction,
  } from "../../components/dataEntryDetails/DataEntryDetailsDucks";
import { Interface } from "readline";
import { wait } from "@testing-library/react";

function CompleteReviewPopUp(props: any) {
    const { setShowCompleteReviewPopUp, transactionId } = props;
    const coIssues = Array.isArray(props.qaIssues) ? props.qaIssues.filter((issue: any) => (issue.qaErrorTypeName == "CO" || issue.qaErrorTypeName == "QC") && issue.active && !issue.resolved) : [];
    const pdIssues = Array.isArray(props.qaIssues) ? props.qaIssues.filter((issue: any) => (issue.qaErrorTypeName == "PD" || issue.qaErrorTypeName == "FAR") && issue.active && !issue.resolved) : [];

    const onClickCancel = () => {
        onClose();
        setShowCompleteReviewPopUp(false);
    }

    const onClickComplete = () => {
        onClose();
        setShowCompleteReviewPopUp(false);
        props.completeTransaction(transactionId);
        props.setWait(true);
        setTimeout(() => {
            props.goToNextTransaction();
            props.clearPreviousTransactionOnComplete();
            props.setWait(false);
            props.onChangeDataEntryTab(1, false)
        }, 1000);
    }

    const onClose = () => {
        props.resetCompleteStatusCheck();
        props.resetFeeScheduleCheck();
    }

    useLayoutEffect(() => {
        props.getCompleteStatusCheck(transactionId);
        if(transactionId != null)
            {
                props.getFeeSchedulesCheck(transactionId);
            }
    },[]);

    return(
        <div>
            <Modal className="cancel-dimension complete-transaction-modal" show={true}>
                <div className="alert-container" >
                    <Modal.Title className="cancel-header">
                        <span className="info-icon"></span>
                        <div className="cancel-header-text">
                            {coIssues.length > 0 || pdIssues.length > 0
                                ? "Outstanding Issues"
                                : `Complete QA Review - ${transactionId}`}
                        </div>
                    </Modal.Title>
                    <Modal.Body>
                        <Container style={{display: "flex", flexDirection: "column"}}>
                            {props.feeSchedulesCheck === false ?
                            <>
                            <Row style={{textAlign:"center"}}>
                                <Col xs={12}>
                                <Row>
                                    <Col xs={12}>
                                    <div className="delete-confirmation-text">
                                        <p>
                                            Unable to complete due to missing fee schedules on documents
                                        </p>
                                    </div>
                                </Col>
                                </Row>
                                <Row className="button-align">
                                    <Col xs={3} md={3} className="d-flex justify-content-center align-items-center">
                                        <a href="#!" onClick={onClickCancel} className="modal-cancel" style={{marginLeft: "0"}}>
                                            Cancel
                                        </a>
                                    </Col>
                                </Row>
                                </Col>
                            </Row>
                            </> :
                            <>
                            {coIssues.length && props.feeSchedulesCheck != undefined ?
                                <>
                                    <Row><p>Please resolve the following outstanding QC issues before completing review</p></Row>
                                    <div className="qaCO_Issue_Table">
                                        {coIssues.map(issue =>
                                            <Row className="qaCO_Issue_Info">
                                                <Col md={4} className="first-col nonlink">
                                                    ({issue.qaErrorTypeName}) {issue.qaErrorName}
                                                </Col>
                                                <Col md={4} className="middle-col nonlink">
                                                    {issue.firstName} {issue.lastName}
                                                </Col>
                                                <Col md={4} className="middle-col nonlink">
                                                    Page {issue.pageNumber}
                                                </Col>
                                            </Row>
                                        )}
                                    </div>
                                    {pdIssues.length != 0 && <hr className="hr-class"/>}
                                    <div className="qaPD_Issue_Table">
                                        {pdIssues.map(issue =>
                                            <Row className="qaPD_Issue_Info">
                                                <Col md={4} className="first-col nonlink">
                                                    ({issue.qaErrorTypeName}) {issue.qaErrorName}
                                                </Col>
                                                <Col md={4} className="middle-col nonlink">
                                                    {issue.firstName} {issue.lastName}
                                                </Col>
                                                <Col md={4} className="middle-col nonlink">
                                                    Page {issue.pageNumber}
                                                </Col>
                                            </Row>
                                        )}
                                    </div>
                                </>
                                :
                                props.completeStatusCheck.status && props.feeSchedulesCheck != undefined ?
                                <Row style={{textAlign:"center"}}>
                                    <Col xs={12}>
                                    <Row>
                                        <p>If the transaction has been reviewed and is ready for completion, please complete.</p>
                                    </Row>
                                    <Row>
                                        <Col xs={12} >
                                            <div id="NewStatus" className="alert-text-background-orange" >
                                                <p className="mb-0" style={{textAlign:"center"}}>
                                                    The transaction status will change to <b>{props.completeStatusCheck.status}</b> upon completion and cannot be undone.
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                    </Col>
                                </Row> :
                                <Row style={{textAlign:"center"}}>
                                    <Col xs={12}>
                                        <div>Determining likely completions status.  Please wait...</div>
                                    </Col>
                                </Row>
                            }

                            <Row className="button-align ">
                                {coIssues.length == 0 ?
                                    <>
                                        <Col xs={3} className="d-flex justify-content-center align-items-center">
                                            <a href="#" onClick={onClickCancel} className="modal-cancel" style={{marginLeft: "0"}}>
                                                Cancel
                                            </a>
                                        </Col>
                                        <Col xs={9} className="d-flex justify-content-center align-items-center">
                                            <IconWithButton
                                                buttonText={"Complete QA Review & Release"}
                                                onButtonClick={onClickComplete}
                                                isSave={true}
                                                hideArrowIcon={true}
                                                isDisabled={!props.completeStatusCheck.status || !props.feeSchedulesCheck  }
                                            />
                                        </Col>
                                    </>
                                :
                                 <Col xs={12} className="d-flex justify-content-center align-items-center">
                                    <IconWithButton
                                        buttonText={"Back to Transaction"}
                                        rotateArrow={180}
                                        onButtonClick={onClickCancel}
                                    />
                                 </Col>
                                }
                            </Row>
                            </>}

                        </Container>
                    </Modal.Body>
                </div>
            </Modal>
        </div>
    )
}

function mapStateToProps(state: any, props: any) {
    return {
        completeStatusCheck: state.dataEntryState.completeStatusCheck,
        feeSchedulesCheck: state.dataEntryState.feeSchedulesCheck
    }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    getCompleteStatusCheck: (transactionId: string) => dispatch(getCompleteStatusCheckAction(transactionId)),
    getFeeSchedulesCheck: (transactionId: string) => dispatch(getFeeSchedulesCheckAction(transactionId)),
    resetCompleteStatusCheck: () => dispatch(resetCompleteStatusCheckStateAction()),
    resetFeeScheduleCheck: () => dispatch(resetFeeScheduleCheckStateAction())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompleteReviewPopUp);
